<template>
	<div class="import-wrapper">
		<span class="import-tab">
			{{ patient.length }} Patients Recognized
		</span>

		<div class="sub-title">
			<span>
				Please confirm each column label
			</span>
			
			<div class="column-error" v-if="columnError !== '' && patient.length > 0">
				<DangerIcon></DangerIcon>
				Please choose a column for <span v-html="columnError"></span> before proceeding.
			</div>
		</div>
		
		<div class="table">
			<table>
				<thead>
					<tr>
						<td v-for="(column, index) in columnBack"
							:key="index">
							<el-select size="small" style="min-width:100px;width:100%;" v-model="columnMatch[index]"
								@change="change(index)">
								<el-option v-for="columnType in columnTypes"
									:key="columnType.key"
									:value="columnType.key"
									:label="columnType.label"
									:class="{select: columnType.key === 'none'}">
								</el-option>
							</el-select>
						</td>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(patientRow, rowIndex) in visiblePatient"
						:key="rowIndex">
						<td v-for="(column, index) in patientRow"
							:key="index"
							:class="index ===0 ? 'first' : ''">
							{{ column }}
						</td>
					</tr>
					<tr v-if="visiblePatient.length < patient.length">
						<td class="expand" :colspan="columnBack.length">
							<el-button type="text" @click="expandPatient" >
								Show more patients <i class="el-icon el-icon-arrow-down"></i>
							</el-button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import ImportTable from '.'



const COLUMN_TYPE = [
	{
		key: 'none',
		label: 'Select'
	},
	{
		key: 'date',
		label: 'Date'
	},
	{
		key: 'time',
		label: 'Time'
	},
	{
		key: 'doctor',
		label: 'Provider'
	},
	{
		key: 'name',
		label: 'Name'
	},
	{
		key: 'phone',
		label: 'Phone'
	},
	{
		key: 'email',
		label: 'Email Address'
	},
	{
		key: 'birthdate',
		label: 'Date of Birth'
	},
	{
		key: 'event',
		label: 'Event Keywords'
	}
]

export default {
	name: 'confirm-column-import-table',
	extends: ImportTable,

	props: {
		columnError: {
			type: String
		}
	},

	data() {
		return {
			columnTypes: COLUMN_TYPE,
			//headColumn: this.headColumnMatch(),
			columnMatch: this.columnBackMatch(),
			showPatients: 10,
		}
	},

	mounted() {
		this.$emit('totalEventCount', this.totalEventCount)
		this.$emit('change', this.getColumnConfirmObj(this.columnMatch))
	},

	computed: {
		visiblePatient() {
			return this.patient.slice(0, this.showPatients)
		}
	},

	methods: {
		change(index) {
			const newVal = this.columnMatch[index]
			if(newVal !== 'event')
				Object.keys(this.columnMatch).forEach((currKey) => {
					if(parseInt(currKey) !== index && this.columnMatch[currKey] === newVal)
						delete this.columnMatch[currKey]
				})
			this.$emit('change', this.getColumnConfirmObj(this.columnMatch))
		},
		expandPatient() {
			this.showPatients += 10
		},
		newColumn() {
			var column = {}
			this.headColumn.forEach(({ id }, index) => {
				if (id && id !== 'none') {
					if (! column[id])
						column[id] = {}
					column[id][index] = 10000
				}
			})
			if(!column.doctor)
				column.doctor = {}
			if(!column.name)
				column.name = {}
			if(!column.date)
				column.date = {}
			if(!column.email)
				column.email = {}
			return column
		},
		headColumnMatch() {
			var head = []
			var maxLength = 0

			this.patient.forEach((patient) => {
				patient.row.forEach((row) => {
					maxLength = Math.max(row.length, maxLength)
				})
			})

			for (let i = 0 ; i < maxLength ; i++) {
				let match = Object.keys(this.column)
					.filter((c) => this.column[c][i] != null)
					.sort((a, b) => (this.column[b][i] - this.column[a][i]))

				head.push({
					match,
					id: match[0]
				})
			}

			return head
		},
		/**
		 * Matches column to index where the are presented
		 */
		columnBackMatch() {
			return this.columnBack.reduce((acc, column, index) => {
				acc[index] = column.id
				return acc
			}, {})
		},
		getColumnConfirmObj(columnMatch) {
			return Object.entries(columnMatch).reduce((acc, [strIndex, columnId]) => {
				if(!columnId || columnId === 'none')
					return acc
				const index = parseInt(strIndex)
				if(columnId !== 'event')
					acc[columnId] = index
				else
					acc[columnId] = acc[columnId] ? [index, ...acc[columnId]] : [index]
				return acc
			}, {})
		}

	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";

.table {
	overflow-x: scroll;

	.expand {
		text-align: center;
		border-bottom: none !important;
		border-right: none;
		button {
			font-size: 12px;
			font-weight: 600;
			color: #4a9bf9;
		}
	}

	table {
		width: auto;
		background: white;
		margin-bottom: 10px;
		tbody {
			tr {
				td {
					vertical-align: top;
					padding: 2px 4px;
					border-right: solid 1px #dfdfdf;
					border-top: solid 1px #dfdfdf;
				}
				td.first {
					border-left: 1px solid #dfdfdf;
				}
			}
			tr:last-child {
				td {
					border-bottom: 1px solid #dfdfdf;
				}
			}
		}
	}
}
</style>

<style>
.el-select-dropdown .select{
	color: #b2b2b2;
}
</style>

<style scoped>
.import-wrapper >>> .el-tabs__header {
	background-color: #f8f8f8;
}
.import-wrapper >>> .el-tabs__item.is-active {
	background-color: #ffffff;
	border: 1px solid #e4e7ed !important;
	border-bottom: 1px solid #e4e7ed !important;
	top: 2px;
}
.import-wrapper >>> .el-tabs__nav {
	border: none !important;
}
.import-wrapper >>> .el-tabs__item {
	border: none !important;
}
.import-wrapper >>> .el-tabs__content {
	padding-right: 22px;
	padding-left: 15px;
}
</style>
